<template>
    <v-dialog v-model="dialog" persistent transition="scale-transition" max-width="600px">
        <v-card class="elevation-1">
            <ValidationObserver ref="obsCancellationReason" v-slot="{ invalid, validated }" :immediate="isEdit">
                <v-form name="form" @submit.prevent="saveCancellationReason">
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click.native="handleModal">
                            <v-icon>fas fa-times-circle</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{ isEdit ? 'Editar' : 'Nuevo' }} Motivo de cancelacion</v-toolbar-title>
                        <v-spacer></v-spacer>

                        <v-toolbar-items>
                            <v-btn class="primary" type="submit" :disabled="invalid || !validated">
                                <v-icon class="ma-2" dense large left>fas fa-save</v-icon>{{ isEdit ? 'Guardar cambios' : 'Guardar motivo' }}
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" sm="12" md="7">
                                <ValidationProvider rules="required" v-slot="{ errors, valid}" :immediate="isEdit">
                                    <v-text-field label="Nombre del motivo*" prepend-icon="fas fa-comment-slash"
                                    required clearable v-model="form.name"
                                    :error-messages="errors" :success="valid">
                                    </v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="12" md="5">
                                <ValidationProvider rules="required" v-slot="{ errors, valid}" :immediate="isEdit">
                                    <v-select label="Modulo*" prepend-icon="fas fa-layer-group" required
                                    :items="modules" item-text="text" item-value="value"
                                    v-model="form.module"
                                    :error-messages="errors" :success="valid">
                                    </v-select>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" v-if="isEdit">
                                <v-checkbox class="mx-2" v-model="form.deleted" persistent-hint
                                :false-value="false" :true-value="true"
                                :hint="(form.deleted ? 'Habilitar ' : 'Desactivar ') + 'motivo en el sistema'"
                                :label="form.deleted ? 'Motivo inactivo' : 'Motivo activo'">
                                </v-checkbox>
                            </v-col>
                        </v-row>
                        <small>* Indica son campos requeridos</small>
                    </v-card-text>
                </v-form>
            </ValidationObserver>
        </v-card>
    </v-dialog>
</template>

<script>
import CancellationReasonDataService from '@/service/catalogo/cancellationReason/cancellationReasonDataService';
import { CANCELLATION_MODULES } from '@/utils/cancellationModules';
export default {
    name: "FormCancellationReason",
    props: {
        dialog: { default: false },
        item: { type: Object, default: () => null },
        initialize: { type: Function },
        handleModal: { type: Function }
    },
    data () {
        return {
            modules: CANCELLATION_MODULES,
            form: this.item ? { ...this.item } : { name: "", module: null }
        }
    },
    computed: {
        isEdit() { return !!(this.item && this.item.id); }
    },
    methods: {
        resetData(){
            this.$refs.obsCancellationReason.reset();
            this.handleModal();
        },
        saveCancellationReason(){
            this.$refs.obsCancellationReason.validate().then( isValid => {
                if( !isValid ) return;
                const request = this.isEdit
                    ? CancellationReasonDataService.update( this.form )
                    : CancellationReasonDataService.create( this.form );
                request.then( rsp => {
                    if (rsp.status === 200 || rsp.status === 201) {
                        this.resetData();
                        this.initialize();
                        this.$swal.fire({ position: 'top-end', icon: 'success', title: 'Genial!!', text: `Motivo ${this.isEdit ? 'actualizado' : 'registrado'} correctamente`, showConfirmButton: false, timer: 3500 });
                    }
                    if( rsp.status === 401 || rsp.status === 417 || rsp.status === 400 || rsp.status === 404 ){
                        this.$swal.fire({ position: 'top-end', icon: 'error', title: rsp.data.message, showConfirmButton: false, timer: 3500 });
                    }
                }).catch( err => {
                    this.$swal.fire({ position: 'top-end', icon: 'error', title: `Motivo no ${this.isEdit ? 'actualizado' : 'registrado'}`, text: err.response?.data?.message, showConfirmButton: false, timer: 3500 });
                });
            }).catch( err => {
                this.$swal.fire({ position: 'top-end', icon: 'error', text: err.message, title: 'Por favor verifique que los campos esten llenos correctamente', showConfirmButton: false, timer: 3500 });
            });
        }
    }
}
</script>
